export const RECENTLY_SEARCHED_LOCALITIES_RECORD = 'rslocalities';
